export default function capitaliseWord(word: string) {
	return word.substring(0, 1).toUpperCase() + word.substring(1);
}
